import { render, staticRenderFns } from "./DefaultPopUp.vue?vue&type=template&id=54e24fda&scoped=true&"
import script from "./DefaultPopUp.vue?vue&type=script&lang=js&"
export * from "./DefaultPopUp.vue?vue&type=script&lang=js&"
import style1 from "./../../../../../assets/css/argon-clear.css?vue&type=style&index=1&id=54e24fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e24fda",
  null
  
)

export default component.exports